import React from "react";
import { createRoot } from "react-dom/client"; // Import createRoot for React 18
import App from "./App";
import * as serviceWorker from "./serviceWorker";

// Create the root element
const rootElement = document.getElementById("root");

// Use createRoot to render the app
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
